import { render, staticRenderFns } from "./SrcManage.vue?vue&type=template&id=edb269f4&scoped=true&"
import script from "./SrcManage.vue?vue&type=script&lang=js&"
export * from "./SrcManage.vue?vue&type=script&lang=js&"
import style0 from "./SrcManage.vue?vue&type=style&index=0&id=edb269f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb269f4",
  null
  
)

export default component.exports